import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";

function NotFound() {
  return (
    <div>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        fontFamily: "'Poppins', sans-serif",
        textAlign: "center",
        padding: "120px 32px 60px"
      }}>
        <h1 style={{ fontSize: "100px", color: "#2EBCB3", marginBottom: "8px", fontWeight: "800" }}>404</h1>
        <h2 style={{ fontSize: "28px", marginBottom: "16px", color: "#1B2A3B" }}>Page Not Found</h2>
        <p style={{ fontSize: "16px", color: "#5A6B7D", marginBottom: "32px", maxWidth: "400px", lineHeight: "1.6" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" style={{ padding: "12px 28px", backgroundColor: "#2EBCB3", color: "white", borderRadius: "6px", fontSize: "14px", fontWeight: "600", fontFamily: "'Poppins', sans-serif" }}>
          Back to Home
        </Link>
      </div>
      <Footer />
    </div>
  );
}

export default NotFound;
